import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/Common/Shape.svg'


const _withScopeId = n => (_pushScopeId("data-v-43e28737"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approval-box" }
const _hoisted_2 = { class: "approval-con" }
const _hoisted_3 = { class: "approval-con-item" }
const _hoisted_4 = {
  key: 0,
  class: "approval-name"
}
const _hoisted_5 = { class: "approval-tag" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "position-icon"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("发起")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "position-icon"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("重新发起")
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 已撤回 ")
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "back-icon" }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 回传 ")
const _hoisted_17 = { key: 4 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 撤回回传 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("已通过")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("审批中")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("已驳回")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("待审批 ")
const _hoisted_23 = { class: "approval-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_ExclamationCircleFilled = _resolveComponent("ExclamationCircleFilled")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($props.infoObj.StaffName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.infoObj.StaffName), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (
              $props.staffType == 1 ||
              $props.staffType == 3 ||
              $props.staffType == 4 ||
              $props.staffType == 5 ||
              $props.staffType == 6
            )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($props.staffType == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_a_tag, {
                        color: "#EAF4FF",
                        style: {"border":"1px solid rgba(132, 197, 255, 1)","color":"rgba(30, 138, 232, 1)"}
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_7
                        ]),
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                ($props.staffType == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_a_tag, {
                        color: "#EAF4FF",
                        style: {"border":"1px solid rgba(132, 197, 255, 1)","color":"rgba(30, 138, 232, 1)"}
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_10
                        ]),
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                ($props.staffType == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_a_tag, { color: "default" }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_ExclamationCircleFilled, { style: {"color":"#b9b9b9"} })
                        ]),
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                ($props.staffType == 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_a_tag, {
                        color: "#E4FEFF",
                        class: "back"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _hoisted_16
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                ($props.staffType == 6)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_a_tag, { color: "default" }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_ExclamationCircleFilled, { style: {"color":"#b9b9b9"} })
                        ]),
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($props.infoObj.Status == 2)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "success"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CheckCircleFilled)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }))
                  : ($props.infoObj.Status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "warning"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_ExclamationCircleFilled)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }))
                    : ($props.infoObj.Status == 3)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 2,
                          color: "error"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_CloseCircleFilled)
                          ]),
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        }))
                      : ($props.infoObj.Status === 0)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 3,
                            color: "rgba(255, 251, 230, 1)",
                            style: {"margin-right":"34px","color":"#e87e04","border":"1px solid rgba(255, 213, 191, 1)"}
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_ExclamationCircleFilled, { style: { color: '#E87E04' } })
                            ]),
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_23, _toDisplayString($props.infoObj.ApproveTime), 1)
    ])
  ]))
}